import { ANGEL_BUSINESS_ID, FALLBACK_SUPER_ADMIN_BUSINESS_ID } from "@/constants";

/**
 * Align client-side `businessId` with DB RLS (`get_user_business_id`).
 * Never use a hardcoded "fallback" tenant for employees — that breaks multi-tenant
 * inventory queries vs RLS and shows empty stock for invited team members.
 */
export function resolveClientBusinessId(
  rpcBusinessId: string | null | undefined,
  profileBusinessId: string | null | undefined,
  isReviewboostsServices: boolean
): string | null {
  let resolved = (rpcBusinessId ?? profileBusinessId ?? null) as string | null;
  if (
    isReviewboostsServices &&
    (resolved === ANGEL_BUSINESS_ID || resolved === FALLBACK_SUPER_ADMIN_BUSINESS_ID)
  ) {
    resolved = null;
  }
  return resolved;
}
